import * as ambassadorWixLoyaltyV1Program from './loyalty-v1-program-programs.http.js';
import * as ambassadorWixLoyaltyV1ProgramTypes from './loyalty-v1-program-programs.types.js';
import * as ambassadorWixLoyaltyV1ProgramUniversalTypes from './loyalty-v1-program-programs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getLoyaltyProgram(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.GetLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramTypes.GetLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.GetLoyaltyProgramResponse,
  ambassadorWixLoyaltyV1ProgramTypes.GetLoyaltyProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.getLoyaltyProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkGetLoyaltyProgram(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.BulkGetLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramTypes.BulkGetLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.BulkGetLoyaltyProgramResponse,
  ambassadorWixLoyaltyV1ProgramTypes.BulkGetLoyaltyProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.bulkGetLoyaltyProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/bulk/programs',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLoyaltyProgram(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.UpdateLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramTypes.UpdateLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.UpdateLoyaltyProgramResponse,
  ambassadorWixLoyaltyV1ProgramTypes.UpdateLoyaltyProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.updateLoyaltyProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/program',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function activateLoyaltyProgram(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.ActivateLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramTypes.ActivateLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.ActivateLoyaltyProgramResponse,
  ambassadorWixLoyaltyV1ProgramTypes.ActivateLoyaltyProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.activateLoyaltyProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program/activate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function pauseLoyaltyProgram(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.PauseLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramTypes.PauseLoyaltyProgramRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.PauseLoyaltyProgramResponse,
  ambassadorWixLoyaltyV1ProgramTypes.PauseLoyaltyProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.pauseLoyaltyProgram(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program/pause',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLoyaltyProgramPremiumFeatures(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.GetLoyaltyProgramPremiumFeaturesRequest,
  ambassadorWixLoyaltyV1ProgramTypes.GetLoyaltyProgramPremiumFeaturesRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.GetLoyaltyProgramPremiumFeaturesResponse,
  ambassadorWixLoyaltyV1ProgramTypes.GetLoyaltyProgramPremiumFeaturesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.getLoyaltyProgramPremiumFeatures(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/program/premium-features',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function enablePointsExpiration(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.EnablePointsExpirationRequest,
  ambassadorWixLoyaltyV1ProgramTypes.EnablePointsExpirationRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.EnablePointsExpirationResponse,
  ambassadorWixLoyaltyV1ProgramTypes.EnablePointsExpirationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.enablePointsExpiration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program/points-expiration/enable',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function disablePointsExpiration(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1ProgramUniversalTypes.DisablePointsExpirationRequest,
  ambassadorWixLoyaltyV1ProgramTypes.DisablePointsExpirationRequest,
  ambassadorWixLoyaltyV1ProgramUniversalTypes.DisablePointsExpirationResponse,
  ambassadorWixLoyaltyV1ProgramTypes.DisablePointsExpirationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Program.disablePointsExpiration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/program/points-expiration/disable',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyProgram as LoyaltyProgramOriginal,
  PointDefinition as PointDefinitionOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  ProgramStatus as ProgramStatusOriginal,
  ProgramStatusWithLiterals as ProgramStatusWithLiteralsOriginal,
  PointsExpiration as PointsExpirationOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  PremiumFeatures as PremiumFeaturesOriginal,
  SocialMediaSettings as SocialMediaSettingsOriginal,
  SocialMediaChannel as SocialMediaChannelOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  GetLoyaltyProgramRequest as GetLoyaltyProgramRequestOriginal,
  GetLoyaltyProgramResponse as GetLoyaltyProgramResponseOriginal,
  BulkGetLoyaltyProgramRequest as BulkGetLoyaltyProgramRequestOriginal,
  BulkGetLoyaltyProgramResponse as BulkGetLoyaltyProgramResponseOriginal,
  ProgramInSite as ProgramInSiteOriginal,
  UpdateLoyaltyProgramRequest as UpdateLoyaltyProgramRequestOriginal,
  UpdateLoyaltyProgramResponse as UpdateLoyaltyProgramResponseOriginal,
  PointsExpirationConfigurationChanged as PointsExpirationConfigurationChangedOriginal,
  PointsExpirationChanges as PointsExpirationChangesOriginal,
  ActivateLoyaltyProgramRequest as ActivateLoyaltyProgramRequestOriginal,
  ActivateLoyaltyProgramResponse as ActivateLoyaltyProgramResponseOriginal,
  LoyaltyProgramActivated as LoyaltyProgramActivatedOriginal,
  PauseLoyaltyProgramRequest as PauseLoyaltyProgramRequestOriginal,
  PauseLoyaltyProgramResponse as PauseLoyaltyProgramResponseOriginal,
  GetLoyaltyProgramDescriptionRequest as GetLoyaltyProgramDescriptionRequestOriginal,
  GetLoyaltyProgramDescriptionResponse as GetLoyaltyProgramDescriptionResponseOriginal,
  UpdateLoyaltyProgramDescriptionRequest as UpdateLoyaltyProgramDescriptionRequestOriginal,
  UpdateLoyaltyProgramDescriptionResponse as UpdateLoyaltyProgramDescriptionResponseOriginal,
  LoyaltyProgramDescriptionUpdated as LoyaltyProgramDescriptionUpdatedOriginal,
  GetLoyaltyProgramPremiumFeaturesRequest as GetLoyaltyProgramPremiumFeaturesRequestOriginal,
  GetLoyaltyProgramPremiumFeaturesResponse as GetLoyaltyProgramPremiumFeaturesResponseOriginal,
  EnablePointsExpirationRequest as EnablePointsExpirationRequestOriginal,
  EnablePointsExpirationResponse as EnablePointsExpirationResponseOriginal,
  PointsExpirationEnabled as PointsExpirationEnabledOriginal,
  DisablePointsExpirationRequest as DisablePointsExpirationRequestOriginal,
  DisablePointsExpirationResponse as DisablePointsExpirationResponseOriginal,
  PointsExpirationDisabled as PointsExpirationDisabledOriginal,
  FeatureEvent as FeatureEventOriginal,
  FeatureEventEventOneOf as FeatureEventEventOneOfOriginal,
  FeatureEnabled as FeatureEnabledOriginal,
  FeatureEnabledReasonOneOf as FeatureEnabledReasonOneOfOriginal,
  Feature as FeatureOriginal,
  FeatureQuantityInfoOneOf as FeatureQuantityInfoOneOfOriginal,
  FeatureContext as FeatureContextOriginal,
  BooleanFeature as BooleanFeatureOriginal,
  QuotaFeature as QuotaFeatureOriginal,
  FeaturePeriod as FeaturePeriodOriginal,
  FeaturePeriodWithLiterals as FeaturePeriodWithLiteralsOriginal,
  QuotaInfo as QuotaInfoOriginal,
  QuotaInfoEntry as QuotaInfoEntryOriginal,
  TransferredFromAnotherAccountReason as TransferredFromAnotherAccountReasonOriginal,
  ReassignedFromSiteReason as ReassignedFromSiteReasonOriginal,
  AssignedFromFloatingReason as AssignedFromFloatingReasonOriginal,
  NewFeatureReason as NewFeatureReasonOriginal,
  ContractSwitchedReason as ContractSwitchedReasonOriginal,
  ContractSwitchClassification as ContractSwitchClassificationOriginal,
  ContractSwitchClassificationWithLiterals as ContractSwitchClassificationWithLiteralsOriginal,
  ManualFeatureCreationReason as ManualFeatureCreationReasonOriginal,
  MigratedFromLegacyReason as MigratedFromLegacyReasonOriginal,
  ManualSyncReason as ManualSyncReasonOriginal,
  FeatureDisabled as FeatureDisabledOriginal,
  FeatureDisabledReasonOneOf as FeatureDisabledReasonOneOfOriginal,
  UnAssingedToFloatingReason as UnAssingedToFloatingReasonOriginal,
  ReplacedByAnotherSubscriptionReason as ReplacedByAnotherSubscriptionReasonOriginal,
  ReassignedToAnotherSiteReason as ReassignedToAnotherSiteReasonOriginal,
  FeatureUpdated as FeatureUpdatedOriginal,
  FeatureUpdatedPreviousQuantityInfoOneOf as FeatureUpdatedPreviousQuantityInfoOneOfOriginal,
  FeatureUpdatedReasonOneOf as FeatureUpdatedReasonOneOfOriginal,
  FeatureCancelled as FeatureCancelledOriginal,
  FeatureCancelledReasonOneOf as FeatureCancelledReasonOneOfOriginal,
  TransferredToAnotherAccountReason as TransferredToAnotherAccountReasonOriginal,
  CancelRequestedReason as CancelRequestedReasonOriginal,
  QuotaExhaustedReason as QuotaExhaustedReasonOriginal,
  FeatureQuotaUsageChanged as FeatureQuotaUsageChangedOriginal,
  Empty as EmptyOriginal,
  LoyaltyAppInstallation as LoyaltyAppInstallationOriginal,
  V1Type as V1TypeOriginal,
  V1TypeWithLiterals as V1TypeWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-v1-program-programs.types.js';
